export function deriveDisplayName(username) {
  const trimmedUsername = (username || '').trim();
  return trimmedUsername || null;
}

export function derivePreviewOrgName(orgName) {
  const trimmedOrgName = (orgName || '').trim();
  return trimmedOrgName || 'Your organization';
}

export function deriveOrgInitial(label) {
  const trimmed = (label || '').trim();
  return trimmed.charAt(0).toUpperCase() || 'W';
}

export function buildOpportunitiesSummaryUserMessage(workEmail) {
  const trimmedEmail = (workEmail || '').trim();
  const recipient = trimmedEmail || 'me';
  return `Generate a summary of all open opportunities and send to ${recipient}`;
}

export function buildPreviewHomeChatMessages(workEmail) {
  const trimmedEmail = (workEmail || '').trim();
  return [
    {
      role: 'user',
      content: buildOpportunitiesSummaryUserMessage(workEmail),
      time: '2:14 PM',
    },
    {
      role: 'agent',
      senderName: 'Master Agent',
      content: trimmedEmail
        ? `I'll compile open opportunities and email the summary to ${trimmedEmail}.`
        : "I'll compile open opportunities and email the summary to you.",
      time: '2:14 PM',
    },
  ];
}

export function buildPreviewChatsMessages(workEmail) {
  const trimmedEmail = (workEmail || '').trim();
  return [
    {
      role: 'user',
      content: buildOpportunitiesSummaryUserMessage(workEmail),
      time: '10:32 AM',
    },
    {
      role: 'agent',
      senderName: 'Master Agent',
      content: trimmedEmail
        ? `You have 12 open opportunities. I'll send the summary to ${trimmedEmail}.`
        : "You have 12 open opportunities. I'll send the summary to you.",
      time: '10:32 AM',
    },
  ];
}
